import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EntityModule } from './components/entity/entity.module';
import { ProviderModule } from './components/provider/provider.module';
import { ReportModule } from './components/report/report.module';
import { ReportViewModule } from './components/report-view/report-view.module';

@NgModule({
  imports: [
    CommonModule,
    EntityModule,
    ProviderModule,
    ReportModule,
    ReportViewModule,
  ],
})

export class PortalReportModule {}
